class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.menuContent = this.mainDetailsToggle.querySelector('.mega-menu__content');
    this.nonMegaMenuLinks = document.querySelectorAll("a.header__menu-item");;
    this.nonMegaMenuLinks.forEach(link => link.addEventListener('mouseover', this.onMouseOverNonMegaMenu.bind(this)));
    this.mainDetailsToggle.addEventListener('mouseover', this.onMouseOver.bind(this));
    this.menuContent.addEventListener('mouseleave', this.onMouseOut.bind(this));
  }

  onMouseOverNonMegaMenu() {
    const openMainDetails = this.header.querySelector('details[open]');

    if(openMainDetails) {
      openMainDetails.removeAttribute('open');
    }
  }

  onMouseOver() {
    const openMainDetails = this.header.querySelector('details[open]');
    
    if(openMainDetails) {
      // if some mainDetails is open already, don't open another one bf closing the other one
      openMainDetails.removeAttribute('open');
    }

    this.mainDetailsToggle.setAttribute('open', '');
    this.onToggle();
  }

  onMouseOut() {
    this.mainDetailsToggle.removeAttribute('open');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
